/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AlertOptions {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}


export function instanceOfAlertOptions(value: any): boolean {
    for (const key in AlertOptions) {
        if (Object.prototype.hasOwnProperty.call(AlertOptions, key)) {
            if (AlertOptions[key as keyof typeof AlertOptions] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AlertOptionsFromJSON(json: any): AlertOptions {
    return AlertOptionsFromJSONTyped(json, false);
}

export function AlertOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertOptions {
    return json as AlertOptions;
}

export function AlertOptionsToJSON(value?: AlertOptions | null): any {
    return value as any;
}

export function AlertOptionsToJSONTyped(value: any, ignoreDiscriminator: boolean): AlertOptions {
    return value as AlertOptions;
}

